$(function () {

    /* HANDLE AJAX ERROR CALLBACK */
    $.ajaxSetup({
        error: function (x, e) {
            if (0 == x.status) {
                _status(_s('You are offline!! Changes Have not been Saved') + '<br /><br />' + _s('Please Check Your Network Connection.'));
            } else if (404 == x.status) {
                _status(_s('Requested URL not found. Please Contact info@humanity.com if this persists.'));
            } else if (500 == x.status) {
                _status(_s('Internal Server Error. Please Contact info@humanity.com if this persists.'));
            } else if ('parsererror' == e) {
                _status(_s('Error - Parsing JSON Request failed. Please Contact info@humanity.com if this persists.'));
            } else if ('timeout' == e) {
                _status(_s('Request Time out. Please Try Again'));
            } else {
                _status(_s('Unknown Error.') + '<br /><br />' + x.responseText + '.<br /> ' + _s('Please Contact info@humanity.com if this persists.'));
            }
        },
        beforeSend: function () {
            _loading();
        },
        success: function () {
            _loaded();
        },
        complete: function () {
            _loaded();
        },
        cache: false
    });
});

var captureImageResponse='',
    token= '',
    isCaptchaRequired = false;

function handleCaptureImage (action){
    var webCamCanvas = document.getElementById('webCamCanvas'),
        photo = webCamCanvas ? webCamCanvas.toDataURL().replace('data:image/png;base64,', '') : '',
        userId = $('#flash_app').attr('user');

    $('#clock_in, #clock_out').addClass('disable-button');

    $.ajax({
        url: '/app/timeclock/terminal/api.php',
        dataType: 'json',
        type: 'post',
        data: {
            module: 'timeclock.picture',
            method: 'CREATE',
            id: userId,
            photo: photo,
            action: action
        },
        cache: false,
    }).done(function ok ( response){
        if (response.hasOwnProperty('error') && response.error) {
            _status(response.error);
            return;
        }

        captureImageResponse='{';

        for (var img in response.data){
            captureImageResponse += '\"' + img + '\":"' + response.data[img] + '\",';
        }

        captureImageResponse = self.captureImageResponse.replace(/,\s*$/, '');
        captureImageResponse += '}';

        $('#clock_in, #clock_out').removeClass('disable-button');
    }).fail(function fail (data){
        _status(data.error);
    });
}

function pluginWebcam (){
    var video = document.getElementById('webCam'),
        canvas = document.getElementById('webCamCanvas'),
        $video = $('#webCam'),
        $canvas = $('#webCamCanvas'),
        context = canvas.getContext('2d'),
        localstream,
        $cam_toggle = $('.cam_toggle'),
        $cam_break = $('#cam_break'),
        apiData= {action: ''};

    // Get access to the camera!
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        navigator.mediaDevices.getUserMedia({ video: true }).then(function (stream) {
            video.srcObject = stream;
            localstream = stream;
            video.play();

            $cam_toggle.hide();

            // Trigger photo take
            $('#capture_bt').on('click', function click () {
                var $this = $(this),
                    btnText = $this.text();

                if (btnText.indexOf(_s('In')) !== -1){
                    apiData.action = 'clockin';
                } else if (btnText.indexOf(_s('Out')) !== -1){
                    apiData.action = 'clockout';
                }

                if (btnText === _s('Take another photo')){
                    // Get access to the camera!
                    navigator.mediaDevices.getUserMedia({ video: true }).then(function (stream) {
                        video.srcObject = stream;
                        localstream = stream;
                        video.play();
                        $this.text(_s('Capture Cam'));
                        $canvas.hide();
                        $video.show();
                        $cam_toggle.hide();
                    });
                } else {
                    context.drawImage(video, 0, 0, 320, 240);
                    video.pause();
                    video.src = '';
                    localstream.getTracks()[0].stop();
                    $this.text(_s('Take another photo'));
                    $video.hide();
                    $canvas.show();
                    $cam_toggle.show();
                    $cam_break.hide();

                    handleCaptureImage(apiData.action);
                }
            });
        });
    }
}
function api (module, method, args, callback, errorCallback) {

    var data = {
        module: module,
        method: method
    };

    $.each(args, function (index, item) {
        data[index] = item;
    });

    $.ajax({
        url: '/app/timeclock/terminal/api.php',
        dataType: 'json',
        type: 'post',
        data: data,
        cache: false,
        success: function (response) {
            if (1 == response.status) {
                if ('function' == typeof callback) {
                    if (false == response.data || null == response.data) {
                        response.data = [];
                    }
                    callback.call(this, response);
                }
            } else {
                if ('function' == typeof errorCallback) {
                    errorCallback.call(this, response);
                }
            }
        }
    });
}

function _status (NewStatus, Secs) {
    if (!Secs) {
        Secs = 3;
    }
    $('#_status').html(NewStatus).fadeIn();
    clearStatus(Secs);
}
function clearStatus (Secs) {
    $(document).stopTime('hide');
    $(document).oneTime(Secs + 's', 'hide', function () {
        $('#_status').fadeOut();
    });
}
function _loading () {
    $('#_loading').show();
}
function _loaded () {
    $('#_loading').hide();
}

function tct_select_employee (employee) {
    if (0 < employee) {
        $('#C').load('/app/timeclock/terminal/content.php?step=employee&employee=' + employee);
    }
}

function getFlashMovie (movieName) {
    var isIE = -1 != navigator.appName.indexOf('Microsoft');

    if (isIE) {
        return window[movieName];
    } else {
        return document[movieName];
    }
}

function captureCam () {
    var $captureBtn = $('#capture_bt');

    webcam.capture();
    webcam.save('/app/timeclock/picture.php');
    _loading();
    $captureBtn.addClass('takeAnotherPhoto').html(_s('Take Another Photo'));
    $captureBtn.on('click', anotherPhoto);
}
var webcamImageData = [],
    webcamImagePos = 0;

function webcamComplete (data) {

    var split = data.split(';');

    $('#preview_pic').html('<img src="' + split[0] + '" />');
    pic_loc = split[2];
    $('#flash_app').hide();
    $('.cam_toggle').css('display', 'inline');
    $('#cam_break').hide();

}

function anotherPhoto () {
    var $captureBtn = $('#capture_bt');

    $('.cam_toggle').css('display', 'none');
    $('#flash_app').show();
    $('#preview_pic').html('');
    $('#pic_links').html('');
    webcam.capture();
    $captureBtn.html(_s('Capture Cam'));
    $captureBtn.on('click', captureCam);
}
function getPicLocation (pic_location) {
    var data = pic_location.split(';');

    pic_loc = data[2];
    _loaded();
    $('.cam_toggle').css('display', 'inline');

}

function tct_login_employee (username) {
    var Req = [],
        captchaMessage = document.getElementById('captcha-message'),
        loginButton = document.getElementById('loginButton');

    loginButton.disabled = true;

    if (username) {
        Req = ['username', 'password'];
    } else {
        Req = ['password'];
    }

    for (i in Req) {
        if (!$('#' + Req[i]).val()) {
            $('#' + Req[i]).focus().effect('highlight', {}, 3000);
            _status(_s('Missing Details'));
            $(window).scrollTop(0);
            loginButton.disabled = false;

            return false;
        }
    }

    captchaMessage.style.setProperty('display', 'none');
    captchaMessage.parentElement.classList.remove('captcha-error');

    if (isCaptchaRequired && grecaptcha.getResponse().length === 0) {
        captchaMessage.style.setProperty('display', 'block');
        captchaMessage.parentElement.classList.add('captcha-error');
        loginButton.disabled = false;

        return false;
    }

    var user_id = $('[name=userid]').val(),
        usernameVal = $('#username').val(),
        password = $('#password').val(),
        captcha = grecaptcha.getResponse();

    api('terminal.login', 'GET', {
        id: user_id,
        username: username ? username : usernameVal,
        password: password,
        captcha: captcha
    }, function (data) {
        _status(_s('Logged In!'));
        $('#C').load('/app/timeclock/terminal/content.php?step=employee&employee=' + data.data);
        token = data.token;
        loginButton.disabled = false;
    }, function (data) {
        var error = data.error;

        var captchaDiv = document.getElementById('captcha-div'),
            captchaFailed = 'captcha-failed',
            isCaptchaFailed = JSON.stringify(error).indexOf(captchaFailed) >= 0,
            isCaptchaVisible = captchaDiv.style.getPropertyValue('display') === 'block';

        if (isCaptchaFailed) {
            isCaptchaVisible && _status(_s('We couldn\'t verify captcha. Please try again.'));
        }

        isCaptchaRequired = error.hasOwnProperty('captchaRequired') ? error.captchaRequired : isCaptchaFailed;

        if (isCaptchaRequired || isCaptchaFailed) {
            captchaDiv.style.setProperty('display', 'block');
            grecaptcha.reset();
        } else {
            captchaDiv.style.setProperty('display', 'none');
        }

        if (typeof error === 'object' && error.hasOwnProperty('error-status')) {
            _loaded();
            _status(_s(error['error-status']));
            loginButton.disabled = false;

            return;
        }
        _loaded();
        _status(_s(error));
        loginButton.disabled = false;
    });
}

function searchEmployees () {
    var search = $('#search_emp').val().toLowerCase();

    if ('' != search) {
        $('#search_result_table').html('');

        $.each(employeeList, function (index, element) {
            if (0 <= element.name.toLowerCase().indexOf(search)) {
                $('#search_result_table').append('<tr><td onClick="setEmployeeToLogin(\'' + element.id + '\', \'' + DOMPurify.sanitize(element.name).replace('\'','\\\'') + '\')" id="search_result_td_' + element.id + '">' + DOMPurify.sanitize(element.name) + '</td></tr>');
            }

            if (0 == $('#chosen_user').val() && element.name.toLowerCase() == search) {
                $('#chosen_user').val(element.id);
            }
        });
        $('#search_result').show();

    } else {
        $('#search_result_table').html('');
        $('#search_result').hide();
    }
}

function setEmployeeToLogin (userId, name) {
    if (0 > userId) {
        userId = 0;
    }
    $('#chosen_user').val(userId);
    $('#search_emp').val(name);
    $('#search_result').hide();
}

function tct_find_and_login_employee () {
    var userId = $('#chosen_user').val();

    if (0 < userId) {
        tct_select_employee(userId);
    } else {
        _status(_s('User not chosen or does not exist. Check provided info and try again.'));
    }
}

var pic_loc = '';

function TCT_ClockIn (user_id, logout) {

    var logoutParam = logout ? 1 : 0,
        $clockInButton = $('#clock_in');

    if ($clockInButton.prop('disabled')) {
        return;
    }

    $clockInButton.prop('disabled', true);

    api('terminal.clockin', 'GET', {
        id: user_id,
        photo: pic_loc || captureImageResponse,
        logout: logoutParam
    }, function (data) {
        _status(data.data);
        if (1 == logoutParam) {
            $('#C').load('/app/timeclock/terminal/content.php');
        } else {
            $('#C').load('/app/timeclock/terminal/content.php?step=employee&employee=' + user_id);
        }
    }, function (data) {
        _status(data.error);
        $clockInButton.prop('disabled', false);
    });
}

function TCT_ClockOut (user_id, logout) {

    var logoutParam = logout ? 1 : 0,
        schedule_id = $('#schedule').val();

    setButtonsState(true);

    api('terminal.clockout', 'GET', {
        id: user_id,
        photo: pic_loc || captureImageResponse,
        schedule: schedule_id,
        logout: logoutParam
    }, function (data) {
        _status(data.data);
        setButtonsState(false);
        if (1 == logoutParam) {
            $('#C').load('/app/timeclock/terminal/content.php');
        } else {
            $('#C').load('/app/timeclock/terminal/content.php?step=employee&employee=' + user_id);
        }
    }, function (data) {
        setButtonsState(false);
        _status(data.error);
    });
}

function setButtonsState(disabled) {
    var breakButton = document.getElementById('break_button'),
        clockOutButton = document.getElementById('clock_out');

    if (breakButton) {
        breakButton.disabled = disabled;
    }

    clockOutButton.disabled = disabled;
}

function TCT_Break (clocktime, user_id, breakout) {
    $('#break_button').prop('disabled', true);
    var event = breakout ? 'breakout' : 'breakin';

    api('timeclock.event', 'CREATE', {
        timeclock: clocktime,
        type: event
    }, function (data) {
        $('#C').load('/app/timeclock/terminal/content.php?step=employee&employee=' + user_id);

    }, function (data) {
        $('#break_button').prop('disabled', false);
        _status(data.error);
    });

}

function TCT_Update (clocktime, user_id) {
    var position = $('#schedule option:selected').val();

    var hid_position = $('#hid_schedule').val();

    if (position != hid_position && !isNaN(+position) && isFinite(position) && 0 < position && 'undefined' != typeof position) {
        api('timeclock.event', 'CREATE', {
            position: position,
            timeclock: clocktime,
            type: 'position'
        }, function (data) {
            $('#C').load('/app/timeclock/terminal/content.php?step=employee&employee=' + user_id);
        }, function (data) {
            _status(data.error);
        });
    }
}

function TCT_UpdateRemoteSite (clocktime, user_id) {
    var location = $('#remote_site option:selected').val();

    if (!isNaN(+location) && isFinite(location) && 0 < location && 'undefined' != typeof location) {
        api('timeclock.event', 'CREATE', {
            location: location,
            timeclock: clocktime,
            type: 'location'
        }, function (data) {
            $('#C').load('/app/timeclock/terminal/content.php?step=employee&employee=' + user_id);
        }, function (data) {
            _status(data.error);
        });
    }
}

function TCT_UpdateTips (clocktime, user_id) {
    var tips = $('#tc_tips').val();

    if (!isNaN(tips) && 0 <= tips) {
        api('timeclock.event', 'CREATE', {
            tips: tips,
            timeclock: clocktime,
            type: 'tips'
        }, function (data) {
            $('#C').load('/app/timeclock/terminal/content.php?step=employee&employee=' + user_id);
        }, function (data) {
            _status(data.error);
        });
    } else {
        _status(_s('Tips not valid'));
    }
}

function TCT_UpdateTerminalNotes (clocktime, user_id) {
    var notes = $('#tc_terminal_notes').val();

    if (0 < $.trim(notes).length) {
        api('timeclock.event', 'CREATE', {
            notes: $.trim(notes),
            timeclock: clocktime,
            type: 'notes'
        }, function (data) {
            _status(_s('Notes Added!'));
            $('#C').load('/app/timeclock/terminal/content.php?step=employee&employee=' + user_id);
        }, function (data) {
            _status(data.error);
        });
    } else {
        _status(_s('Notes not valid'));
    }
}

function appendCaptchaToLoginForm() {
    $('.captcha-wrapper').appendTo($('#C'));
}
